<div id="{{'btn-' + itemCode + '-favorite' | lowercase }}" class="favorite-container cursor-pointer" [ngClass]="showPaddingtop ? 'pt8': ''" (click)="showConfirmationDialog()">
  <div class="icon-favorite">
    <span *ngIf="!isFavorite" matTooltip="Agregar a favoritos">
      <img src="assets/icons/no-favorite.svg" alt="favorite">
    </span>
    <span *ngIf="isFavorite" matTooltip="Quitar de favoritos">
      <img src="assets/icons/favorite.svg" alt="favorite">
    </span>

  </div>
</div>
